import { TableHeader } from "src/app/shared/models/table";

export const REPORT_LIST_HEADERS: TableHeader[] = [
    {
        name: "Nombre",
        key: "nombre",
        sort: "",
        hasFilters: true
    },
    {
        name: "Tipo",
        key: "tipoReporte",
        sort: "",
        hasFilters: true
    },
    {
        name: "Descripción",
        key: "descripcion",
        sort: "",
        hasFilters: true
    },
    {
        name: "Origen",
        key: "origen",
        sort: "",
        hasFilters: true
    },
]